import getReturnUrl from 'shared/universal/get-return-url';
import getQueryFromWindow from './get-query-from-window';

const getReturnUrlFromWindow = () => {
  const query = getQueryFromWindow();
  return getReturnUrl(query);
};

export default getReturnUrlFromWindow;
